import { tv } from "@ui/lib/tv";
import { Button } from "@ui/primitives/Button";

const reactionPill = tv({
  base: [
    "flex cursor-pointer items-center gap-1 rounded-full px-2 py-0.5 text-xs leading-5 outline-none",
    "transition-colors focus-visible:ring-2 focus-visible:ring-red-300",
    "bg-neutral-50 text-neutral-700 hover:bg-neutral-100",
  ],
  variants: {
    /** Yours reads as a chip you can take back, not a tally you are looking at. */
    isMine: {
      true: "bg-red-50 text-red-500 ring-1 ring-red-400 hover:bg-red-100",
    },
  },
});

export interface MessageReaction {
  emoji: string;
  count: number;
  reacted: boolean;
}

export interface ReactionPillsProps {
  /** Accessible label builder — receives the emoji and its count. */
  labelFor: (reaction: MessageReaction) => string;
  onToggle: (emoji: string) => void;
  reactions: MessageReaction[];
}

export function ReactionPills({ labelFor, onToggle, reactions }: ReactionPillsProps) {
  if (reactions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1">
      {reactions.map((reaction) => (
        <Button
          key={reaction.emoji}
          aria-label={labelFor(reaction)}
          aria-pressed={reaction.reacted}
          className={reactionPill({ isMine: reaction.reacted })}
          onPress={() => onToggle(reaction.emoji)}
        >
          <span aria-hidden="true">{reaction.emoji}</span>
          <span aria-hidden="true">{reaction.count}</span>
        </Button>
      ))}
    </div>
  );
}
